var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reply-message"},[_vm._v("这是回复的消息[预留]")])
}
var staticRenderFns = []

export { render, staticRenderFns }